import { Component, OnInit, Inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AnwService } from 'src/app/Services/ANW/anw.service';
import { FirestoreReference, Run, Course, Ninja } from 'src/app/Classes/schema';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BreadcrumbsService } from 'src/app/Services/Breadcrumbs/breadcrumbs.service';
import { NewNinjaComponent } from '../../ninja/new-ninja/new-ninja.component';
import { MatSpinnerContainerComponent } from '../../mat-spinner-container/mat-spinner-container.component';

const fakeNinja = new Ninja();
fakeNinja.name = "+ Add new ninja";
const fakeRef = { id: "", path: "", data: fakeNinja };

@Component({
  selector: 'app-new-run',
  templateUrl: './new-run.component.html',
  styleUrls: ['./new-run.component.css']
})
export class NewRunComponent implements OnInit {
  run: Run;
  ninja: Ninja;
  ninjas: FirestoreReference<Ninja>[];
  formControl: FormControl;
  filteredOptions: Observable<FirestoreReference<Ninja>[]>;
  newNinjaName: string;

  constructor(
    private dialogRef: MatDialogRef<NewRunComponent>,
    private anw: AnwService,
    @Inject(MAT_DIALOG_DATA) public courseData: { course: FirestoreReference<Course> },
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.formControl = new FormControl();
    this.run = new Run();
    this.ninja = new Ninja();

    this.ninjas = this.anw.initNinjas();
    this.anw.getNinjas().subscribe(refs => this.ninjas = refs);

    this.filteredOptions = this.formControl.valueChanges.pipe(
      map((value: string) => {
        if (!value || value === '') {
          return [];
        }
        const weakMatch = (value1: string, value2: string) => value1.toLowerCase().includes(value2.toLowerCase());
        const result = this.ninjas
          .filter(ninja => weakMatch(ninja.data.name, value))
        if (result.length === 0) {

          if (value != fakeNinja.name) {
            this.newNinjaName = value;
          }
          return [fakeRef];
        }
        return result;
      }
      ));
    this.run.courseId = this.courseData.course.id;
    this.run.courseName = this.courseData.course.data.cityName + ' ' + this.courseData.course.data.type + ', season ' + this.courseData.course.data.seasonId
  }

  saveButtonHandler() {
    const fhs = this.anw.fhs;
    fhs.writeDoc("runs", this.run);
    console.log("Saved!");
    this.dialogRef.close(this.run.ninjaId);
  }

  autocompleteselect(option: FirestoreReference<Ninja>) {
    if (option.id) {
      this.ninja.name = option.data.name;
      this.run.ninjaName = option.data.name;
      this.run.ninjaId = option.id;
      this.dialogRef.close(this.run.ninjaId);
    } else {
      this.dialog
        .open(NewNinjaComponent, { width: '500px', data: { name: this.newNinjaName } })
        .afterClosed()
        .subscribe((ninja: Ninja) => {
          this.ninja = ninja;
          this.run.ninjaName = ninja.name;
          this.run.ninjaId = ninja.id();

          const fhs = this.anw.fhs;
          const spinner = this.dialog.open(MatSpinnerContainerComponent, { width: '500px' })
          fhs.writeDoc("runs", this.run).then(id => {
            spinner.close();
            this.dialogRef.close(this.run.ninjaId);
          });
        });
    }
  }
}
